export default __webpack_public_path__ + "static/media/watches4.1d90265e.jfif";